/* globals console, module, require */
/* jshint esversion:6, globalstrict:true */
'use strict';

const BackboneRadio = require('backbone.radio'),
    jQuery = require('jquery'),
    Marionette = require('backbone.marionette'),
    _ = require('lodash'),
    // models & collections
    user = require('../models/user'),
    Vacancies = require('../collections/vacancies'),
    // views
    // Create = require('./create'),
    ModalDialog = require('./modalDialog'),
    Table = require('./table'),
    // utilities
    enumerations = require('../utilities/enumerations'),
    formProcessor = require('../utilities/formProcessor').processor,
    templates = require('../utilities/handlebars').templates,
    EOL = null;

module.exports = Marionette.View.extend({
    attributes: {
        class: 'vacancies'
    },
    channels: {
        console: BackboneRadio.channel('console')
    },
    childViewEvents: {
        'edit:delete': 'onEditDelete',
        'edit:save':   'onEditSave',
        //
        'edit:end': function (options) {this.trigger('edit:end', options);},
        'edit:inProgress': function (options) {this.trigger('edit:inProgress', options);},
        'edit:start': function (options) {this.trigger('edit:start', options);}
    },
    events: {
        'click button': 'onClickButton'
    },
    regions: {
        table: {el: 'div[name=table]', replaceElement: true}
    },
    tagName: 'div',
    template: templates.vacanciesList,
    //
    initialize: function () {
        this.collection = new Vacancies([], {unitId: this.options.unitId, hasAdminAccess: this.options.hasAdminAccess});
        this.listenTo(this.collection, 'all', _.bind(function (event) {
            switch (event) {
                case 'add':
                    this.trigger('vacancy:added');
                    break;
                case 'destroy':
                    this.trigger('vacancy:destroyed');
                    break;
                case 'reset':
                    this.render();
                    break;
                default:
                    break;
            }
        }, this));
        this.templateContext = function () {
            return {
                hasAdminAccess: this.options.hasAdminAccess,
                empty: this.options.hasAdminAccess || this.collection.length ? false : true
            };
        };
    },
    onClickButton: function (event) {
        const action = event.currentTarget.dataset.action;
        switch (action) {
            case 'add':
                this.getChildView('table').create();
                break;
            default:
                console.log('vacanciesList.onClickButton - action:%s', action);
                break;
        }
        return false;
    },
    onEditSave: function (serializedArray) {
        this.collection.save(serializedArray);
    },
    onEditDelete: function (vacancyId) {
        let vacancy = this.collection.get(vacancyId);
        this.modalDialog = new ModalDialog({template: templates.delete, templateContext: {type: 'vacancyLabel', name: vacancy.attributes.availableDate.substr(0, 10)}, modalModal: true});
        this.modalDialog.on('modalDialog:delete', _.bind(function (o) {
            vacancy.destroy();
            vacancy = null;
        }, this));
    },
    onRender: function () {
        if (this.collection.length || this.options.hasAdminAccess) {
            this.showChildView('table', new Table({title: null, collection: this.collection, emptyMessage: 'noVacanciesLabel', statify: this.statify}));
        }
        return this;
    },
    statify: function (form, name) {
        const processedForm = formProcessor(form.serializeArray(), 'vacancies');
        let el;
        if (processedForm.id !== 0) {
            // id === 0 is vacancy create and there's no vacancyFillReasonTypeId select...
            el = form.find('[name=vacancyFillReasonTypeId]');
            el.prop('disabled', processedForm.vacancyStatusTypeId !== enumerations.codeValues.vacancyStatusTypeClosedFilled);
            if (el.prop('disabled')) {
                el.val(-1);
            } else {
                el.find('option:first').prop('disabled', true);
                if (name === 'vacancyStatusTypeId') {
                    // only set to first value if change of status caused the call
                    el[0].selectedIndex = 1;
                }
            }
        }
    }
});
